import { z } from 'zod';
import { Json } from '~/lib/database.types';

const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
const jsonSchema: z.ZodType<Json> = z.lazy(() =>
  z.union([literalSchema, z.array(jsonSchema), z.record(jsonSchema)])
);

export const MessageContentTypeMinAttachmentEnum = z.enum(['text', 'links', 'products']);
export const MessageContentTypeEnum = z.enum(['text', 'links', 'products', 'attachments']);
export type MessageContentType = z.infer<typeof MessageContentTypeEnum>

export const InsertMessageSchema = z.object({
  author: z.enum(['assistant', 'user']), 
  author_account_id: z.string().nullable().optional(),
  client_id: z.string(),
  content: z.string().nullable().optional(),
  content_type: MessageContentTypeEnum, 
  created_at: z.string().optional(),
  id: z.string().optional(),
  message: z.string(),
  session_id: z.string(),
  token_usage: z.number().optional(),
  updated_at: z.string().optional(),
});

export const MessageSchema = z.object({
  author: z.enum(['assistant', 'user']).optional(), 
  author_account_id: z.string().nullable().optional(),
  client_id: z.string().optional(),
  content: z.string().nullable().optional(),
  content_type: MessageContentTypeEnum.optional(), 
  created_at: z.string().optional(),
  id: z.string().optional(),
  message: z.string().optional(),
  session_id: z.string().optional(),
  token_usage: z.number().optional(),
  updated_at: z.string().optional(),
});